import { handleErrors } from "../util/api-utils";

export function searchAgencies(request, successCallback) {
    fetch("api/Search/AgencySearch", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
};

export function searchAgents(request, successCallback) {
    fetch("api/Search/AgentSearch", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
};

export function salesLeaderAgentSearch(request, successCallback) {
    fetch("api/Search/SalesLeaderAgentSearch", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
};

export function getOtpFieldsFromInterview(request, successCallback, errorCallback, finallyCallback) {
    fetch("api/Search/GetOtpFieldsFromInterview", {
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(request)
    })
        .then(handleErrors)
        .then(successCallback)
        .catch((error) => errorCallback(error?.body))
        .finally(finallyCallback);
};

export function getOfficeReportsToOptions(successCallback) {
    fetch("api/Search/GetOfficeReportToOptions", {
        method: "get",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(console.error);
};

export function getAgentInterviewStatuses() {
    return fetch("api/Search/GetAgentInterviewStatuses", {
        method: "get",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(handleErrors);
};